// GED partagée cabinet ↔ client — masques de nommage, utilitaires et magasin.
// Repris de ged.jsx (maquette Claude Design). Les documents sont ceux de la
// table DocumentGED (partagée avec le portail client MyALFA Link), lus et
// écrits via l'API /api/ged.

// Arborescence commune avec MyALFA Link depuis le 30/10/2026 (celle de Link
// fait référence, plus « Juridique » et « Contrats & mission cabinet ») : un
// document est rangé au même endroit des deux côtés. Codes et libellés
// identiques à ARBRE de backend-myalfa (services/gedDossiers.js), qui fait la
// traduction vers le chemin lisible de MyALFA Link.
export const GED_TREE = [
  { id: "admin", l: "Administratif", subs: [{ id: "kbis", l: "Kbis & Statuts" }, { id: "autorisations", l: "Autorisations & Certifications" }, { id: "corresp", l: "Correspondances" }] },
  { id: "juridique", l: "Juridique", dyn: true },
  { id: "contrats", l: "Contrats", subs: [{ id: "clients", l: "Clients" }, { id: "fournisseurs", l: "Fournisseurs" }, { id: "bail", l: "Bail & Immobilier" }] },
  { id: "mission", l: "Contrats & mission cabinet", subs: [] },
  { id: "assurances", l: "Assurances", subs: [{ id: "rcpro", l: "RC Pro" }, { id: "vehicules", l: "Véhicules" }, { id: "multirisque", l: "Multirisque" }] },
  { id: "compta", l: "Comptabilité & Fiscal", subs: [{ id: "bilans", l: "Bilans & Liasses" }, { id: "tva", l: "Déclarations TVA" }, { id: "releves", l: "Relevés bancaires" }] },
  { id: "social", l: "RH & Social", subs: [{ id: "travail", l: "Contrats de travail" }, { id: "paie", l: "Bulletins de paie" }, { id: "dpae", l: "DPAE" }] },
  { id: "materiel", l: "Matériel & Équipements", subs: [{ id: "achats", l: "Factures d'achat" }, { id: "garanties", l: "Certificats & Garanties" }] },
  { id: "divers", l: "Divers", subs: [] },
];
// Limites des dépôts, identiques au serveur (gedController.js) : formats
// acceptés par MyALFA Link et 20 Mo par fichier.
export const GED_EXTENSIONS = [".docx", ".pdf", ".png", ".jpg", ".jpeg", ".webp", ".heic", ".xls", ".xlsx"];
export const GED_TAILLE_MAX = 20 * 1024 * 1024;

export const GED_TOKENS = {
  DATE: { l: "Date du document", type: "date" },
  PERIODE: { l: "Période", type: "month" },
  EXE: { l: "Exercice", type: "year" },
  BANQUE: { l: "Banque", type: "text", ph: "ex. BNP" },
  TIERS: { l: "Tiers", type: "text", ph: "ex. Orange" },
  SALARIE: { l: "Salarié", type: "text", ph: "NOM Prénom" },
  OBJET: { l: "Objet", type: "text", ph: "ex. Approbation des comptes" },
};
// Noms au format demandé par le cabinet : « Comptes annuels 2025.pdf »,
// « Déclaration de TVA 09-2026.pdf » (la barre / est interdite dans un nom de
// fichier). Mêmes libellés que le classement automatique du serveur
// (services/gedDocuments.js) pour les LM, mandats et documents réglementaires.
export const GED_MASKS = [
  { id: "comptes", l: "Comptes annuels", p: "Comptes annuels {EXE}", f: "compta/bilans" },
  { id: "liasse", l: "Liasse fiscale", p: "Liasse fiscale {EXE}", f: "compta/bilans" },
  { id: "facture", l: "Facture", p: "Facture {TIERS} {DATE}", f: "compta" },
  { id: "paie", l: "Bulletin de paie", p: "Bulletin de paie {SALARIE} {PERIODE}", f: "social/paie" },
  { id: "statuts", l: "Statuts", p: "Statuts {DATE}", f: "juridique" },
  { id: "kbis", l: "Extrait Kbis", p: "Extrait Kbis {DATE}", f: "juridique" },
  { id: "sirene", l: "Avis de situation SIRENE", p: "Avis de situation SIRENE {DATE}", f: "juridique" },
  { id: "pv", l: "PV d'assemblée", p: "PV d'assemblée {DATE} {OBJET}", f: "juridique" },
  { id: "ldm", l: "Lettre de mission", p: "Lettre de mission {EXE}", f: "mission" },
  { id: "mandat", l: "Mandat SEPA", p: "Mandat SEPA {DATE}", f: "mission" },
  { id: "tva", l: "Déclaration de TVA", p: "Déclaration de TVA {PERIODE}", f: "compta/tva" },
  { id: "cfe", l: "CFE", p: "CFE {EXE}", f: "compta" },
  { id: "is", l: "Impôt sur les sociétés", p: "Impôt sur les sociétés {EXE}", f: "compta" },
  { id: "ts", l: "Taxe sur les salaires", p: "Taxe sur les salaires {EXE}", f: "compta" },
  { id: "tvs", l: "Taxe sur les véhicules de sociétés", p: "Taxe sur les véhicules de sociétés {EXE}", f: "compta" },
  { id: "memento", l: "Mémento fiscal", p: "Mémento fiscal {EXE}", f: "compta" },
  { id: "releve", l: "Relevé bancaire", p: "Relevé bancaire {BANQUE} {PERIODE}", f: "compta/releves" },
  { id: "rib", l: "RIB", p: "RIB {DATE}", f: "compta/releves" },
  { id: "courrier", l: "Courrier", p: "Courrier {TIERS} {DATE} {OBJET}", f: "admin/corresp" },
  { id: "confrere", l: "Lettre au confrère", p: "Lettre au confrère {DATE}", f: "admin/corresp", vis: "interne" },
  { id: "note", l: "Note interne", p: "Note interne {DATE} {OBJET}", f: "admin/corresp", vis: "interne" },
];


// Accès à la GED : tous les utilisateurs connectés, comme la fiche client
// (ouverture décidée le 15/10/2026 ; l'API n'est plus réservée aux testeurs).
export const gedPeutVoir = (u) => !!u;

// Auteur des dépôts au format de la maquette : « A. HOARAU ». Les comptes
// MyALFA n'ont pas d'ordre stable entre name et lastName : le nom de famille
// est celui écrit en majuscules.
const enMajuscules = (t) => !!t && t === t.toUpperCase() && t !== t.toLowerCase();
export function gedSignature(u) {
  const a = (u?.name || "").trim();
  const b = (u?.lastName || "").trim();
  const [nom, prenom] = enMajuscules(b) && !enMajuscules(a) ? [b, a] : [a, b];
  if (!nom) return prenom;
  return `${prenom ? prenom[0].toUpperCase() + ". " : ""}${nom.toUpperCase()}`;
}

// Utilisateur connecté et cabinet, fournis par l'écran (registre de module,
// comme procPeople pour les procédures).
let MOI = "";
let CABINET = "";
export const gedSetContexte = (moi, cabinet) => {
  MOI = moi || "";
  CABINET = cabinet || "";
};
export const gedMoi = () => MOI || "Cabinet";
export const gedCabinet = () => CABINET || "Votre cabinet";

// Texte comparable pour la recherche : sans accents, sans casse, ponctuation
// et séparateurs (_ - ' ’) ramenés à des espaces. « société » trouve
// « SOCIETE », « mam zelle » trouve « MAM'ZELLE ».
export const gedNorm = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
// Tous les mots de la recherche présents, dans n'importe quel ordre.
export const gedCorrespond = (texte, recherche) => {
  const t = gedNorm(texte);
  return gedNorm(recherche).split(" ").filter(Boolean).every((m) => t.includes(m));
};

const gedSan = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9-]+/g, "-").replace(/^-+|-+$/g, "");
const gedCode = (c) => gedSan(c.name).toUpperCase().slice(0, 18).replace(/-+$/, "");
const gedToday = () => new Date();
const gedISO = (d) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
const gedFmt = (iso) => iso ? iso.split("-").reverse().join("/") : "—";
const gedExt = (n) => { const m = /\.[A-Za-z0-9]{2,5}$/.exec(n || ""); return m ? m[0].toLowerCase() : ".pdf"; };
const gedJurName = (iso, objet) => `${iso.replace(/-/g, " ")} - ${String(objet || "").trim()}`;
// Caractères interdits dans un nom de fichier remplacés par un tiret.
const gedNomFichier = (s) => String(s || "").replace(/[\\/:*?"<>|]+/g, "-").replace(/\s+/g, " ").trim();
const gedTokVal = (t, v) => {
  if (!v) return null;
  const T = GED_TOKENS[t];
  if (T.type === "date") return v; // AAAA-MM-JJ
  if (T.type === "month") return v.split("-").reverse().join("-"); // MM-AAAA
  if (T.type === "text") return gedNomFichier(v) || null;
  return String(v);
};
// Juridique : sous-dossiers et dépôt de plusieurs fichiers sans contrainte de
// renommage (le masque y est facultatif, le nom d'origine est gardé).
const gedEstJuridique = (folder) => folder === "__newjur" || folder === "juridique" || String(folder || "").startsWith("juridique/");
const gedNomOrigine = (orig) => gedNomFichier(String(orig || "").replace(/\.[A-Za-z0-9]{2,5}$/, "")) || "Document";
const gedParts = (mask, vals, client) => mask.p.split(/(\{\w+\})/).filter(Boolean).map((seg) => {
  const m = /^\{(\w+)\}$/.exec(seg);
  if (!m) return { txt: seg };
  if (m[1] === "CLIENT") return { txt: gedCode(client) };
  const v = gedTokVal(m[1], vals[m[1]]);
  return v ? { txt: v } : { txt: GED_TOKENS[m[1]].l, missing: true };
});
const gedTokens = (mask) => [...mask.p.matchAll(/\{(\w+)\}/g)].map((m) => m[1]).filter((t) => t !== "CLIENT");
const gedDefaults = () => {
  const t = gedToday(); const pm = new Date(t.getFullYear(), t.getMonth() - 1, 1);
  return { DATE: gedISO(t), PERIODE: pm.getFullYear() + "-" + String(pm.getMonth() + 1).padStart(2, "0"), EXE: String(t.getFullYear() - 1) };
};
// Destinataire de la notification : contact de la fiche client (nom, prénom,
// email) ; à défaut, la valeur de repli de la maquette.
const gedRecipient = (client) => {
  const nom = `${client.prenomClient || ""} ${client.nomClient || ""}`.trim();
  return { name: nom || "Dirigeant", email: client.email || `contact@${gedSan(client.name).toLowerCase()}.fr` };
};
const gedSubs = (root, st) => root.dyn ? [...st.jur].sort((a, b) => b.l.localeCompare(a.l)) : root.subs;
const gedPathLabel = (path, st) => {
  const [r, s] = path.split("/"); const root = GED_TREE.find((x) => x.id === r);
  if (!root) return path;
  const sub = s && gedSubs(root, st).find((x) => x.id === s);
  return sub ? `${root.l} › ${sub.l}` : root.l;
};


/* ---------- Magasin (par client, alimenté par l'API) ---------- */
// Cache des GED déjà chargées et abonnés (même interface get / sub que la
// maquette) ; les écritures passent par l'API puis mettent le cache à jour.
const cache = {};
const abonnes = new Set();
const notifier = () => abonnes.forEach((f) => f());

// Auteur d'un document déposé par le client : le contact de la fiche, comme
// la maquette (le portail n'enregistre pas de nom).
const avecAuteur = (client) => (d) => ({ ...d, by: d.by || (d.origin === "client" ? gedRecipient(client).name : "Cabinet") });

export const GedStore = {
  get: (c) => cache[c.id] || { jur: [], docs: [], chargement: true },
  sub: (f) => {
    abonnes.add(f);
    return () => abonnes.delete(f);
  },
  // Remplace l'état d'un client à partir de la réponse de l'API.
  poser: (c, data) => {
    cache[c.id] = { jur: data.sousDossiers, docs: data.documents.map(avecAuteur(c)), notification: data.notification || null };
    notifier();
  },
  erreur: (c, message) => {
    cache[c.id] = { ...(cache[c.id] || { jur: [], docs: [] }), chargement: false, erreur: message };
    notifier();
  },
  // Documents créés ou modifiés : fusion dans le cache.
  documents: (c, docs) => {
    const st = GedStore.get(c);
    const parId = new Map(docs.map((d) => [d.id, avecAuteur(c)(d)]));
    const existants = st.docs.map((d) => parId.get(d.id) || d);
    const nouveaux = [...parId.values()].filter((d) => !st.docs.some((x) => x.id === d.id));
    cache[c.id] = { ...st, docs: [...nouveaux, ...existants] };
    notifier();
  },
  // Document supprimé (ou suppression annulée : GedStore.documents le remet).
  retirer: (c, id) => {
    const st = GedStore.get(c);
    cache[c.id] = { ...st, docs: st.docs.filter((d) => d.id !== id) };
    notifier();
  },
  sousDossier: (c, sd) => {
    const st = GedStore.get(c);
    if (!st.jur.some((j) => j.id === sd.id)) cache[c.id] = { ...st, jur: [...st.jur, sd] };
    notifier();
  },
};

export { gedSan, gedCode, gedToday, gedISO, gedFmt, gedExt, gedJurName, gedTokVal, gedParts, gedTokens, gedDefaults, gedRecipient, gedSubs, gedPathLabel, gedNomFichier, gedEstJuridique, gedNomOrigine };
